import { css } from 'linaria';

export const variantsSelectionGroup = css`
  gap: var(--space-50);
`;
